export const DEFAULT_PAGE = 0;
export const DEFAULT_PAGE_SIZE = 25;
export const DEFAULT_PAGE_SIZE_OPTIONS = [15, 25, 50, 100];
export const DEFAULT_LARGE_PAGE_SIZE_OPTIONS = [25, 50, 100, 200, 500];
export const DEFAULT_SMALL_PAGE_SIZE_OPTIONS = [15, 25];
